/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return AiAgentFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<AiAgentFeatureFlagsWithDefaults>): AiAgentFeatureFlagsWithDefaults {
        let obj = Object.assign(new AiAgentFeatureFlagsWithDefaults(), model);
        AiAgentFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentFeatureFlagsWithDefaults>): AiAgentFeatureFlagsWithDefaults {
        if (!model) return null;
        return AiAgentFeatureFlagsWithDefaults.newInstance(<AiAgentFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.AiAgentFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiAgentFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    aiag_2602_b_mcp: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2603_b_concierge: boolean = true;

    /**
     * Flag's default value
     */
    aiag_2504_f_test_flag: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2603_f_portfolio_health_dashboard: boolean = true;

    /**
     * Flag's default value
     */
    aiag_2603_f_waste_analysis_dashboard: boolean = true;

    /**
     * Flag's default value
     */
    aiag_2603_f_expiry_renewal_dashboard: boolean = true;

    /**
     * Flag's default value
     */
    aiag_2604_f_knowledge_graph_browser: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2604_b_ro_agent: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2604_b_assessment_agent: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2604_b_finops_agent: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2604_b_bedrock_agent: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2604_b_anthropic_agent: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2604_b_graphion_agent: boolean = false;

    /**
     * Flag's default value
     */
    aiag_2605_a_report_annotations: boolean = true;

    /**
     * Flag's default value
     */
    aiag_2605_b_mcp_resource_utilisation_tool: boolean = false;

}
